import React from "react"
import BifrostButton from "../../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../BifrostPageComponent/BifrostModal/BifrostModal"

const FTPModal = ({ states, actions }) => {
	const { state } = states
	const { confirmHandler, cancelHandler } = actions

	return (
		<BifrostModal
			title={"Disable FTP"}
			open={state.openWarnningModal}
			// setOpen={(flag) => openWarnningModal(flag)}
			modalPage={<p style={{ color: "black" }}>FTP cannot be re-enabled without starting a new session. Are you sure you want to force disable FTP on this device?</p>}
			modalActions={
				<>
					<BifrostButton type="submit" style={{ display: "inline-block" }} onClick={() => confirmHandler()}>
						Confirm
					</BifrostButton>
					<BifrostButton style={{ display: "inline-block" }} onClick={() => cancelHandler()} color="gray">
						Cancel
					</BifrostButton>
				</>
			}
		/>
	)
}

FTPModal.propTypes = {}

export default FTPModal
